import { Box, Button, Typography } from "@mui/material";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import React, { useEffect } from "react";

import {
    httpRequest,
    isDev,
    onRequestError,
    setStorage,
} from "../../helper/global";
import LargeLogo from "../LargeLogo/LargeLogo";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LOCAL_STORAGE_KEY } from "../../helper/constant";
import { setUserProfile } from "../../reducers/userSlice";
import { setPermissionConfig } from "../../reducers/permissionSlice";

export default function Login() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLoginSuccess = async (response) => {
        // Send the response token to your backend for further verification
        const result = await httpRequest(
            "user/login",
            {
                idToken: response.credential,
            },
            "POST",
            (error) => {
                onRequestError(dispatch, null, {
                    title: error.title,
                    message: error.message,
                });
            }
        );

        if (result === false) {
            return;
        }

        //store jwt token in local storage
        setStorage(LOCAL_STORAGE_KEY.token, result.payload.sessionToken);

        dispatch(
            setUserProfile({
                profile: result.payload.user,
                sessionToken: result.payload.sessionToken,
            })
        );

        dispatch(setPermissionConfig(result.payload.permissionConfig));

        navigate("/patients");
    };

    const handleLoginFailure = (error) => {
        console.error("Login Failure:", error);
    };

    return (
        <Box>
            {isDev() && (
                <Box
                    display={"flex"}
                    justifyContent={"center"}
                    sx={{ backgroundColor: "red", m: 1 }}
                >
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                        DEVELOPMENT VERSION
                    </Typography>
                </Box>
            )}

            <LargeLogo />

            <Box display={"flex"} justifyContent={"center"} sx={{ pt: "20%" }}>
                <GoogleOAuthProvider
                    clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                >
                    <GoogleLogin
                        onSuccess={handleLoginSuccess}
                        onError={handleLoginFailure}
                    />
                </GoogleOAuthProvider>
            </Box>
        </Box>
    );
}
